import * as vp from 'vopay';
import { FunctionComponent, useState } from 'react';
import styles from './InterestAccountsPage.module.scss';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';

const { Box, Select, Button, DateRangePicker, AVAILABLE_TIMEZONES } = vp;
type TransactionSearchParams = {
  accountType: string;
  timeRange: [vp.Timestamp, vp.Timestamp];
  timeZone: vp.Timezone;
};

type SearchFormProps = {
  hasInvalidEndDate: boolean;
  hasLongTermAccount: boolean;
  shouldShowEndDateError: boolean;
  setShouldShowEndDateError: (event: boolean) => void;
  onSearch: (searchParams: TransactionSearchParams) => void;
};

type FC = FunctionComponent<SearchFormProps>;

const InterestHistorySearchForm: FC = (props: SearchFormProps) => {
  const { hasInvalidEndDate, hasLongTermAccount, shouldShowEndDateError, setShouldShowEndDateError, onSearch } = props;

  const [timeRange, setTimeRange] = useState<[vp.Timestamp, vp.Timestamp]>();
  const [currentAccountType, setCurrentAccountType] = useState<string>('All');

  const accountTypeOptions = {
    All: 'All',
    'short-term': 'Short Term',
    'long-term': 'Long Term',
  };

  const { userSettings } = useUserSettingsProvider();

  const accountTypeOptionsArray = Object.entries(accountTypeOptions).map(([key]) => ({
    value: key,
    label: accountTypeOptions[key as keyof typeof accountTypeOptions],
  }));

  const [currentTimeZone, setCurrentTimeZone] = useState<vp.Timezone>(userSettings.timezone);
  const timezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const initialTimeZones = AVAILABLE_TIMEZONES.map((tz) => ({
    label: tz,
    value: tz,
  })).filter((tz) => !tz.value.toLowerCase().includes('utc') && !tz.value.includes(timezoneName));
  const timeZoneOptions = [
    {
      label: 'UTC',
      value: 'UTC',
    },
    {
      label: timezoneName,
      value: timezoneName,
    },
    ...initialTimeZones,
  ];

  return (
    <Box jc="sb" flx="col" width="100%" gap="md">
      <Box jc="center" gap="sm" wrap="wrap">
        <div className={styles.datePickerContainer}>
          <DateRangePicker
            triggerVariant="outlineShadow"
            onChange={(range) => {
              if (range && range[0] && range[1]) {
                setTimeRange(range);
              }
            }}
            // placeholder=From', 'To']}
            hasInvalidEndDate={hasInvalidEndDate}
            shouldShowEndDateError={shouldShowEndDateError}
            setShouldShowEndDateError={setShouldShowEndDateError}
          />
        </div>
        {hasLongTermAccount && (
          <div className={styles.Interesetselect}>
            <Box ps="sm" width="150px">
              <Select
                version="2"
                placeholder="Acc. Type"
                options={accountTypeOptionsArray}
                name="status"
                value={currentAccountType}
                onBlur={() => {}}
                onChange={(e) => {
                  setCurrentAccountType(e.target.value);
                }}
              />
            </Box>
          </div>
        )}
        <Box>
          <Select
            version="2"
            placeholder="Timezone"
            options={timeZoneOptions}
            name="timeZone"
            value={currentTimeZone}
            onBlur={() => {}}
            filterable
            onChange={(e) => {
              setCurrentTimeZone(e.target.value as vp.Timezone);
            }}
            sort={false}
          />
        </Box>
        <Box ps="sm">
          <Button
            id="search-transaction-history"
            label="Search"
            width="100px"
            height="51px"
            borderRadius="10px"
            onClick={() => {
              timeRange &&
                onSearch({
                  accountType: currentAccountType,
                  timeRange,
                  timeZone: currentTimeZone,
                });
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default InterestHistorySearchForm;
